import React, { Component } from 'react';
import { Element } from 'react-scroll';

class TitleSection extends Component {
  render() {
    return (
      <Element name="home-section">
        <div className="row img-library align-items-center">
          <div className="col-lg-12 title-section-text">
            <h1 className="text-uppercase">Benvenuto!</h1>
            <h3 className="">Mi chiamo Alessio Mantelli e sono un editor freelance</h3>
            <br/>
            <h6 className="text-uppercase">Servizi editoriali per autori e case editrici</h6>
          </div>
        </div>
      </Element>
    );
  }
}

export default TitleSection;



// WEBPACK FOOTER //
// ./src/components/TitleSection.js